import { render, staticRenderFns } from "./confirm-commande.vue?vue&type=template&id=30921569&scoped=true&"
import script from "./confirm-commande.vue?vue&type=script&lang=js&"
export * from "./confirm-commande.vue?vue&type=script&lang=js&"
import style0 from "./confirm-commande.vue?vue&type=style&index=0&id=30921569&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30921569",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
